/* Pensualizei cart drawer live (Store 3). Complementa cart-drawer.js.
   FIX: nunca redireciona pro /cart; espera o componente ficar pronto. */

(function () {
  'use strict';
  if (window.PensualizeiCartDrawerLiveV2) return;
  window.PensualizeiCartDrawerLiveV2 = true;

  var pendingRefresh = null;

  function getRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }
  function getDrawer() { return document.querySelector('cart-drawer'); }

  function syncEmptyState(drawer) {
    if (!drawer) return;
    var hasItems = !!drawer.querySelector('#CartDrawer-CartItems .cart-item');
    drawer.classList.toggle('is-empty', !hasItems);
    var items = drawer.querySelector('cart-drawer-items');
    if (items) items.classList.toggle('is-empty', !hasItems);
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    syncEmptyState(drawer);
    if (typeof drawer.open === 'function') { drawer.open(); }
    else { drawer.classList.add('active'); drawer.style.visibility = 'visible'; }
  }

  function waitForDrawerReady(maxWait) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function check() {
        var d = getDrawer();
        if (d && typeof d.open === 'function') { resolve(d); return; }
        if (Date.now() - start > maxWait) { resolve(d || null); return; }
        setTimeout(check, 16);
      })();
    });
  }

  function replaceFallback(sections, drawer) {
    var drawerMarkup = sections && sections['cart-drawer'];
    if (!drawerMarkup) { openDrawer(drawer); return; }
    var frag = new DOMParser().parseFromString(drawerMarkup, 'text/html');
    var fresh = frag.querySelector('#CartDrawer');
    var current = drawer ? drawer.querySelector('#CartDrawer') : null;
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var bubbleMarkup = sections && sections['cart-icon-bubble'];
    if (bubbleMarkup) {
      var bfrag = new DOMParser().parseFromString(bubbleMarkup, 'text/html');
      var freshBubble = bfrag.querySelector('.shopify-section');
      var currentBubble = document.querySelector('#cart-icon-bubble');
      if (freshBubble && currentBubble) currentBubble.innerHTML = freshBubble.innerHTML;
    }
    openDrawer(drawer);
  }

  function refreshAndOpen(trigger) {
    if (pendingRefresh) return pendingRefresh;
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    pendingRefresh = waitForDrawerReady(3000).then(function (drawer) {
      var url = new URL(getRoot(), window.location.origin);
      url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
      url.searchParams.set('_ps_cart', String(Date.now()));
      return fetch(url.toString(), { method: 'GET', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' })
        .then(function (response) { if (!response.ok) throw new Error('cart fetch failed: ' + response.status); return response.json(); })
        .then(function (sections) {
          var d = getDrawer();
          if (!d) return;
          if (typeof d.renderContents === 'function') {
            try { d.renderContents({ sections: sections, id: null }); }
            catch (e) { console.warn('[Pensualizei] native render failed; fallback', e); replaceFallback(sections, d); }
            setTimeout(function () { syncEmptyState(d); }, 60);
          } else { replaceFallback(sections, d); }
        });
    }).catch(function (error) {
      console.error('[Pensualizei] cart update error', error);
      var d = getDrawer(); if (d) openDrawer(d);
    }).then(function () {
      if (trigger) trigger.removeAttribute('aria-busy');
      pendingRefresh = null;
    });
    return pendingRefresh;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('#cart-icon-bubble');
    if (!trigger) return;
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    refreshAndOpen(trigger);
  }, true);

  document.addEventListener('cart:item-added', function () { refreshAndOpen(null); });

  function psSyncAndOpen() { var d = getDrawer(); if (!d) return; syncEmptyState(d); openDrawer(d); }
  document.addEventListener('pensualizei:cart-added', function () {
    psSyncAndOpen();
    setTimeout(psSyncAndOpen, 80);
    setTimeout(psSyncAndOpen, 300);
  });

  /* ===== Melhorias de conversao (aditivas, reversiveis) ===== */

  function psFixSaleBadges(scope) {
    (scope || document).querySelectorAll('.badge').forEach(function (b) {
      if (/\bSAVE\b/i.test(b.textContent)) {
        var t = b.textContent.replace(/\bSAVE\b/i, '').replace(/\s+/g, ' ').trim();
        if (!/off/i.test(t)) t = t.replace(/%\s*$/, '% OFF');
        b.textContent = t;
      }
    });
  }

  function psFixAssurances() {
    document.querySelectorAll('.ps-purchase-assurances span').forEach(function (s) {
      if (/produ[cç][aã]o sob demanda/i.test(s.textContent)) { s.textContent = 'Enviado em até 5 dias úteis'; }
    });
  }

  function psAddOffers() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.ps-offers')) return;
    var price = document.querySelector('.product__info-container .price') || document.querySelector('.product__info-wrapper .price') || document.querySelector('.template-product .product-price-current');
    if (!price || !price.parentNode) return;
    var box = document.createElement('div');
    box.className = 'ps-offers';
    box.setAttribute('style', 'margin:10px 0 2px;display:flex;flex-direction:column;gap:5px;font-size:12.5px;color:#666;');
    function line(iconClass, text) {
      var row = document.createElement('div'); row.setAttribute('style', 'display:flex;align-items:center;gap:8px;');
      var ic = document.createElement('i'); ic.className = 'fa ' + iconClass; ic.setAttribute('aria-hidden', 'true'); ic.setAttribute('style', 'width:15px;text-align:center;color:#8a8a8a;font-size:12px;');
      var sp = document.createElement('span'); sp.textContent = text;
      row.appendChild(ic); row.appendChild(sp); return row;
    }
    box.appendChild(line('fa-truck', 'Frete grátis acima de R$ 190'));
    box.appendChild(line('fa-credit-card', 'Pix ou em até 12x no cartão'));
    price.parentNode.insertBefore(box, price.nextSibling);
  }

  function psFixRecommendations() {
    var h = document.querySelector('.product-recommendations__heading');
    if (h && /produtos?\s+recomendados/i.test(h.textContent)) { h.textContent = 'Você também vai gostar'; }
  }

  function psHideEmptyReviews() {
    var sec = document.getElementById('ps-product-reviews');
    if (!sec) return;
    var hasReviews = !!sec.querySelector('.jdgm-rev');
    var isEmpty = /Nenhum item encontrado|Seja o primeiro/i.test(sec.textContent);
    if (hasReviews) { sec.style.display = ''; }
    else if (isEmpty && !sec.dataset.psRevealed) { sec.style.display = 'none'; }
  }

  function psShareData() {
    var url = location.origin + location.pathname;
    var t = (document.querySelector('meta[property="og:title"]') || {}).content || (document.querySelector('.product__title') || {}).textContent || document.title;
    var img = (document.querySelector('meta[property="og:image"]') || {}).content || '';
    return { url: url, title: (t || '').replace(/\s+/g, ' ').trim(), image: img };
  }

  function psRoundBtn(iconHTML, label, handler) {
    var a = document.createElement('button');
    a.type = 'button';
    a.setAttribute('aria-label', label);
    a.title = label;
    a.setAttribute('style', 'display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:50%;border:1px solid rgba(0,0,0,.14);color:#333;background:#fff;cursor:pointer;padding:0;transition:background .15s ease,color .15s ease,border-color .15s ease,transform .15s ease;');
    a.innerHTML = iconHTML;
    a.addEventListener('mouseenter', function () { a.style.background = '#111'; a.style.color = '#fff'; a.style.borderColor = '#111'; a.style.transform = 'translateY(-1px)'; });
    a.addEventListener('mouseleave', function () { a.style.background = '#fff'; a.style.color = '#333'; a.style.borderColor = 'rgba(0,0,0,.14)'; a.style.transform = 'none'; });
    a.addEventListener('click', handler);
    return a;
  }

  var PS_FA = function (cls) { return '<i class="fa ' + cls + '" aria-hidden="true" style="font-size:16px;line-height:1;"></i>'; };
  var PS_X_SVG = '<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path></svg>';

  function psAddCtaShare() {
    if (!document.body.classList.contains('template-product')) return;
    var gallery = document.querySelector('.template-product .product__media-gallery');
    if (!gallery) return;
    var block = document.getElementById('ps-cta-share');
    if (!block) {
      var d = psShareData();
      block = document.createElement('div');
      block.id = 'ps-cta-share';
      block.setAttribute('style', 'grid-column:1 / -1;margin:16px 0 0;display:flex;align-items:center;justify-content:flex-end;gap:14px;flex-wrap:wrap;');
      var revWrap = document.createElement('div');
      revWrap.id = 'ps-review-cta-wrap';
      revWrap.style.display = 'none';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('style', 'display:inline-flex;align-items:center;gap:8px;padding:11px 18px;border:1px solid #111;border-radius:999px;background:transparent;color:#111;font-size:13px;font-weight:600;cursor:pointer;transition:background .15s ease,color .15s ease;');
      btn.innerHTML = '<i class="fa fa-star-o" aria-hidden="true"></i> Seja o primeiro a avaliar';
      btn.addEventListener('mouseenter', function () { btn.style.background = '#111'; btn.style.color = '#fff'; });
      btn.addEventListener('mouseleave', function () { btn.style.background = 'transparent'; btn.style.color = '#111'; });
      btn.addEventListener('click', function () {
        var rev = document.getElementById('ps-product-reviews'); if (!rev) return;
        rev.dataset.psRevealed = '1'; rev.style.display = 'block';
        rev.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { var w = [].slice.call(rev.querySelectorAll('a,button')).filter(function (e) { return /escrever/i.test(e.textContent); })[0]; if (w) w.click(); }, 500);
      });
      revWrap.appendChild(btn);
      var share = document.createElement('div');
      share.setAttribute('style', 'display:flex;align-items:center;gap:8px;');
      var lbl = document.createElement('span'); lbl.textContent = 'Compartilhe'; lbl.setAttribute('style', 'font-size:12px;color:#888;margin-right:2px;');
      share.appendChild(lbl);
      share.appendChild(psRoundBtn(PS_FA('fa-whatsapp'), 'Compartilhar no WhatsApp', function () { window.open('https://wa.me/?text=' + encodeURIComponent(d.title + ' ' + d.url), '_blank', 'noopener'); }));
      share.appendChild(psRoundBtn(PS_FA('fa-pinterest-p'), 'Salvar no Pinterest', function () { window.open('https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(d.url) + '&media=' + encodeURIComponent(d.image) + '&description=' + encodeURIComponent(d.title), '_blank', 'noopener'); }));
      share.appendChild(psRoundBtn(PS_FA('fa-facebook-f'), 'Compartilhar no Facebook', function () { window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(d.url), '_blank', 'noopener'); }));
      share.appendChild(psRoundBtn(PS_X_SVG, 'Compartilhar no X', function () { window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(d.url) + '&text=' + encodeURIComponent(d.title), '_blank', 'noopener'); }));
      share.appendChild(psRoundBtn(PS_FA('fa-instagram'), 'Compartilhar no Instagram', function () { if (navigator.share) { navigator.share({ title: d.title, url: d.url }).catch(function () {}); } else { window.open('https://instagram.com/store.pensualizei', '_blank', 'noopener'); } }));
      block.appendChild(revWrap);
      block.appendChild(share);
      gallery.appendChild(block);
    }
    var rev = document.getElementById('ps-product-reviews');
    var hasReviews = !!(rev && rev.querySelector('.jdgm-rev'));
    var revWrap2 = document.getElementById('ps-review-cta-wrap');
    if (revWrap2) revWrap2.style.display = hasReviews ? 'none' : '';
  }

  function psEnhance() {
    psFixSaleBadges();
    psFixAssurances();
    psAddOffers();
    psFixRecommendations();
    psHideEmptyReviews();
    psAddCtaShare();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', psEnhance); } else { psEnhance(); }
  [400, 900, 1600, 3000].forEach(function (t) { setTimeout(psEnhance, t); });
  document.addEventListener('variant:change', psEnhance);

  if (document.body.classList.contains('template-product')) {
    var psDeb;
    var mo = new MutationObserver(function () { clearTimeout(psDeb); psDeb = setTimeout(psEnhance, 150); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 25000);
  }

  /* ===== Wishlist: quick-add igual ao catalogo =====
     Injeta o "+" e o dialogo de variacao (card-product-4 via /products/<h>?view=pscard)
     em cada card da wishlist. O pensualizei-card-v2.js usa delegacao, entao o clique funciona. */
  function psWishlistQuickAdd() {
    var rows = document.querySelectorAll('.dtx-table tr[id^="row_"]:not(.grid_template)');
    rows.forEach(function (row) {
      if (row.dataset.psQaDone) return;
      var link = row.querySelector('a.product-name') || row.querySelector('a[href*="/products/"]');
      if (!link) return;
      var parts = (link.getAttribute('href') || '').split('/products/')[1];
      if (!parts) return;
      var handle = parts.split('?')[0].split('#')[0].replace(/\/$/, '');
      if (!handle) return;
      row.dataset.psQaDone = '1';
      fetch('/products/' + handle + '?view=pscard').then(function (r) { return r.text(); }).then(function (html) {
        if (row.querySelector('.ps-wishlist-qa')) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var action = doc.querySelector('[data-ps-card-action]');
        if (!action) return;
        var dialogId = action.getAttribute('aria-controls');
        var dialog = dialogId ? doc.getElementById(dialogId) : doc.querySelector('[data-ps-variant-dialog]');
        var holder = document.createElement('div');
        holder.className = 'ps-wishlist-qa';
        holder.appendChild(document.importNode(action, true));
        if (dialog) holder.appendChild(document.importNode(dialog, true));
        var anchor = row.querySelector('.product-price-cart') || link;
        var host = (anchor && anchor.parentNode) ? anchor.parentNode : row;
        host.appendChild(holder);
      }).catch(function () { row.dataset.psQaDone = ''; });
    });
  }

  if (document.querySelector('dtx-wishlist-grid')) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', psWishlistQuickAdd); } else { psWishlistQuickAdd(); }
    [800, 1800, 3000, 5000].forEach(function (t) { setTimeout(psWishlistQuickAdd, t); });
    var wDeb;
    var wo = new MutationObserver(function () { clearTimeout(wDeb); wDeb = setTimeout(psWishlistQuickAdd, 200); });
    wo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { wo.disconnect(); }, 20000);
  }
})();
